<template>
  <div class="page">
    <div class="path">
      <span class="normal pointer" @click="toEcology()">生态服务</span>
      <span class="normal space">/</span>
      <span class="active">工程师子账号申请详情</span>
    </div>
    <div class="content">
      <div class="title">
        <h2>
          工程师子账号申请
          <span class="tag" :class="['tag' + dataSource.ssoSupplierUserApplyStatus]"
            v-if="dataSource.ssoSupplierUserApplyStatusStr">{{ dataSource.ssoSupplierUserApplyStatusStr }}</span>
        </h2>
        <div class="flex">
          <div class="info-item inline-item">
            <div class="label">申请单号:</div>
            <div class="value">{{ dataSource.supplierUserApplyNo }}</div>
          </div>
          <div class="info-item inline-item">
            <div class="label">评审意见:</div>
            <div class="value">{{ dataSource.auditRemark || "-" }}</div>
          </div>
        </div>
        <div class="flex">
          <div class="info-item inline-item">
            <div class="label">申请人:</div>
            <div class="value">{{ dataSource.name }}</div>
          </div>
          <div class="info-item inline-item">
            <div class="label">申请时间:</div>
            <div class="value">{{ dataSource.createTime }}</div>
          </div>
        </div>
        <div>
          <!-- 审批中 展示 -->
          <el-button v-if="[2].includes(+dataSource.ssoSupplierUserApplyStatus)" type="primary" size="small"
            @click="onShowProcess()">审批详情</el-button>
          <!-- 待提审、已驳回 时显示 -->
          <el-button v-if="[1, 3].includes(+dataSource.ssoSupplierUserApplyStatus)" type="primary" size="small"
            @click="onSubmit()">提交审批</el-button>

          <el-button v-if="[1, 3].includes(+dataSource.ssoSupplierUserApplyStatus)" plain size="small"
            @click="onEdit()">编辑</el-button>
          <!-- 只在驳回时可 作废 -->
          <el-button v-if="[3].includes(+dataSource.ssoSupplierUserApplyStatus)" type="danger" plain size="small"
            @click="onCancel()">作废申请</el-button>
        </div>
      </div>
      <div class="info">
        <h3>申请信息</h3>
        <div>
          <div class="info-item">
            <div class="label">工程师姓名:</div>
            <div class="value">{{ dataSource.ssoSupplierUserName }}</div>
          </div>
          <div class="info-item">
            <div class="label">工程师手机号:</div>
            <div class="value">{{ dataSource.phone }}</div>
          </div>
          <div class="info-item">
            <div class="label">工程师性别:</div>
            <div class="value">{{ dataSource.gender === 0 ? "男" : "女" }}</div>
          </div>
          <div class="info-item">
            <div class="label">开始工作年月:</div>
            <div class="value">{{ dataSource.workBeginDate }}</div>
          </div>
          <div class="info-item">
            <div class="label">行业经验年数:</div>
            <div class="value">{{ dataSource.industryExperienceYear }}</div>
          </div>

          <div class="info-item w-full" style="width: 960px">
            <div class="label">申请备注:</div>
            <div class="value">
              {{ dataSource.remark }}
            </div>
          </div>
          <div class="info-item">
            <div class="label">简历:</div>
            <div class="value">
              <div class="mb-16" v-for="item in resumeFileList" :key="item.ossId">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="label">劳动合同证明:</div>
            <div class="value">
              <div class="mb-16" v-for="item in laborContractFileList" :key="item.ossId">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="label">身份证复印件:</div>
            <div class="value">
              <div class="mb-16" v-for="item in idCardFileList" :key="item.ossId">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="label">保密及安全协议:</div>
            <div class="value">
              <div class="mb-16" v-for="item in securityAgreementsFileList" :key="item.ossId">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="label">半年以上社保缴纳证明:</div>
            <div class="value">
              <div class="mb-16" v-for="item in socialSecurityFileList" :key="item.ossId">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="label">体检证明:</div>
            <div class="value">
              <div class="mb-16" v-for="item in physicalFileList" :key="item.ossId">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="label">意外险证明:</div>
            <div class="value">
              <div class="mb-16" v-for="item in insuranceFileList" :key="item.ossId">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="label">培训记录表:</div>
            <div class="value">
              <div class="mb-16" v-for="item in trainingRecordFileList" :key="item.ossId">
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="审核详情" :visible.sync="dialogVisible" width="1100px">
      <ViewProcess v-if="dialogVisible" :businessKey="businessKey" />
    </el-dialog>
  </div>
</template>
<script>
import ViewProcess from "@/components/view-process/index.vue";
export default {
  components: {
    ViewProcess,
  },
  data() {
    return {
      id: "",
      dataSource: {
        ssoSupplierUserName: "",
        workBeginDate: "",
        industryExperienceYear: "",
        gender: "",
        phone: "",
        remark: "",
      },
      resumeFileList: [],
      laborContractFileList: [],
      idCardFileList: [],
      securityAgreementsFileList: [],
      socialSecurityFileList: [],
      physicalFileList: [],
      insuranceFileList: [],
      trainingRecordFileList: [],
      dialogVisible: false,
      businessKey: "",
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getDataSource();
  },
  methods: {
    onShowProcess() {
      this.businessKey = this.dataSource.businessKey;
      this.dialogVisible = true;
    },
    onEdit() {
      this.$router.push({
        name: "ecologicalServices-account-edit",
        query: { id: this.id },
      });
    },
    onCancel() {
      this.$http
        .post(
          `/front/oms/supplier/UserApply/cancel?businessKey=${this.dataSource.businessKey}`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success("作废成功");
            // 刷新数据
            this.getDataSource();
          }
        });
    },
    onSubmit() {
      this.$http
        .post(`/front/oms/supplier/UserApply/submit?id=${this.id}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success("提交成功");
            // 刷新数据
            this.getDataSource();
          }
        });
    },
    getDataSource() {
      this.$http
        .get(`/front/oms/supplier/UserApply/engineerUserDetail/${this.id}`)
        .then(({ data: res }) => {
          const { code, data } = res;
          console.log(data);

          if (code === 0) {
            this.dataSource = data;
            (data.supplierUserApplyFiles || []).forEach((item) => {
              console.log(item);

              const { businessType } = item;
              switch (+businessType) {
                case 7:
                  this.resumeFileList.push(item);
                  break;
                case 8:
                  this.laborContractFileList.push(item);
                  break;
                case 9:
                  this.idCardFileList.push(item);
                  break;
                case 10:
                  this.securityAgreementsFileList.push(item);
                  break;
                case 11:
                  this.socialSecurityFileList.push(item);
                  break;
                case 12:
                  this.physicalFileList.push(item);
                  break;
                case 13:
                  this.insuranceFileList.push(item);
                  break;
                case 14:
                  this.trainingRecordFileList.push(item);
                  break;
              }
            });
          }
        });
    },
    toEcology() {
      this.$router.push({ name: "ecologicalServices" });
    },
  },
};
</script>
<style lang="scss" scoped>
.page {}

.path {
  height: 36px;
  line-height: 36px;

  .normal {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    color: #999999;
  }

  .active {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    font-weight: 600;
    color: #333333;
  }

  .space {
    margin-right: 8px;
    margin-left: 8px;
  }
}

.content {
  background: #fff;
  padding: 20px;
  min-height: 800px;
}

h2 {
  font-family: Alibaba PuHuiTi;
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
}

h3 {
  font-family: Alibaba PuHuiTi;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
}

.el-button--primary {
  background-color: #2a54d1;
  border-color: #2a54d1;
}

.title {
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.label {
  font-family: Alibaba PuHuiTi;
  font-size: 14px;
  text-align: right;
  color: #666666;
  padding-right: 8px;
}

.info {
  .label {
    width: 180px;
  }

  .value {
    width: 300px;
  }
}

.value {
  flex: 1;
  font-family: Alibaba PuHuiTi;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  word-break: break-all;
}

.flex {
  display: flex;
}

.info-item {
  display: inline-flex;
  margin-bottom: 20px;

  a {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    font-weight: 600;
    text-align: right;
    color: #2a54d1;
  }
}

.mb-16 {
  margin-bottom: 16px;
}

.bold-tag {
  border-radius: 4px;
  padding: 6.5px 18px;
  background: #2a54d1;
  display: inline-block;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  color: #ffffff;
}

.inline-item {
  width: 300px;
}

.tag {
  border-radius: 14px;
  padding: 2px 8px;
  background: #2a54d1;
  font-family: Alibaba PuHuiTi;
  font-size: 12px;
  font-weight: normal;
  color: #ffffff;
  margin-left: 12px;
}

//  1. 待提审 2. 审批中 3. 已驳回 4. 已生效
.tag1 {
  background: #e5a92f;
}

.tag2 {
  background: #2a54d1;
}

.tag3 {
  background: #e93037;
}

.tag4 {
  background: #1fbd13;
}

.pointer {
  cursor: pointer;
}
</style>